<template>
  <div class="company-applyment-module" v-loading="loading">
    <!-- 状态 -->
    <el-affix
      :class="{ 'applyment-page-header-top': affixed, 'applyment-page-header-shrink': sidebarFold, 'applyment-page-header-unfold': !sidebarFold }"
      @change="handleAffixChange"
      :offset="80"
    >
      <el-card>
        <div class="applyment-page-header">
          <div class="status">
            {{ orderStatusFormat(detail.status) }}
            <span class="fs12" v-if="detail.creditStatus">(Credit: {{ creditStatusFormat(detail.creditStatus) }})</span>
          </div>
          <div class="page-header-heading-right">
            <!-- 后付款审批历史记录 -->
            <el-button type="text" icon="el-icon-tickets" @click="openCreditHistoryModal">Credit History</el-button>

            <div class="ml10 opts">
              <!-- 确认收款 - 财务 -->
              <el-button
                v-if="(detail.status === 'UNPAID' || detail.status === 'PARTLY_PAID') && isAuth('finance:financial')"
                type="primary"
                size="medium"
                @click="handleConfirmReceipt"
              >
                Confirm Receipt
              </el-button>
            </div>
            <div class="ml10 opts" v-if="detail.status === 'UNPAID' || detail.status === 'PARTLY_PAID'">
              <!-- 发起后付款 - 财务 -->
              <el-button
                v-if="(!detail.creditStatus || detail.creditStatus == 'REJECTED') && isAuth('finance:creditApply')"
                type="primary"
                size="medium"
                @click="handleCreditApply"
              >
                {{ detail.creditStatus == "REJECTED" ? "Credit Re-apply" : "Credit Apply" }}
              </el-button>
              <!-- 后付款审批 - 财务复核 -->
              <el-button v-if="detail.creditStatus == 'PENDING' && isAuth('finance:audit')" type="primary" size="medium" @click="handleCreditReview">
                Credit Review
              </el-button>
              <!-- 废弃订单 - 财务 -->
              <el-button v-if="detail.creditStatus == 'PASSED' && isAuth('finance:financial')" type="danger" size="medium" @click="handleForfeitOrder">
                Forfeit Order
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </el-affix>

    <!-- 基础信息 -->
    <div class="step mt20">
      <el-card shadow="hover">
        <base-info :detail="detail" />
      </el-card>
    </div>

    <!-- 关联退款单列表 -->
    <div class="step mt20" v-if="detail?.orderRefundList?.length > 0">
      <el-card shadow="hover">
        <linked-refund-order-list :detail="detail" />
      </el-card>
    </div>

    <!-- 确认收款 - 弹窗 -->
    <confirm-receipt ref="confirmReceiptModal" :invoice="detail.invoice"></confirm-receipt>
    <!-- 发起后付款申请 - 弹窗 -->
    <credit-apply ref="creditApplyModal"></credit-apply>
    <!-- 审批后付款申请 - 弹窗 -->
    <credit-review ref="creditReviewModal"></credit-review>
    <!-- 后付款审批历史记录 - 弹窗 -->
    <credit-history ref="creditHistoryModal" :orderId="detail.id"></credit-history>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import BaseInfo from "../modules/baseInfo";
import LinkedRefundOrderList from "../modules/linkedRefundOrderList";
import ConfirmReceipt from "./modal/ConfirmReceipt.vue";
import CreditApply from "./modal/CreditApply.vue";
import CreditReview from "./modal/CreditReview.vue";
import CreditHistory from "./modal/CreditHistory.vue";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  components: {
    BaseInfo,
    LinkedRefundOrderList,
    ConfirmReceipt,
    CreditApply,
    CreditReview,
    CreditHistory,
  },
  data() {
    return {
      affixed: false,
      loading: true,
    };
  },
  computed: {
    ...mapState("finance", ["detail"]),
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
    },
  },
  methods: {
    ...mapActions("finance", ["initOrder", "doForfeitOrder"]),
    ...mapMutations("finance", ["RESET_DETAIL"]),
    handleAffixChange(fixed) {
      this.affixed = fixed;
    },
    // 详情
    async getDetail() {
      this.loading = true;
      try {
        await this.initOrder(this.id);
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    // 确认收款 - 财务
    handleConfirmReceipt() {
      this.$refs.confirmReceiptModal.init();
    },
    // 发起后付款 - 财务
    handleCreditApply() {
      this.$refs.creditApplyModal.init();
    },
    // 后付款审批 - 财务复核
    handleCreditReview() {
      this.$refs.creditReviewModal.init();
    },
    // 后付款审批历史记录
    openCreditHistoryModal() {
      this.$refs.creditHistoryModal.init();
    },
    // 废弃订单 - 财务
    async handleForfeitOrder() {
      await this.$confirm("Forfeit This Order. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.doForfeitOrder({ status: "FORFEITED" })
        .then(() => {
          this.$message({
            message: "success",
            type: "success",
            duration: 1500,
            onClose: () => {},
          });
        })
        .catch(msg => {});
    },
  },
  activated() {
    // 先重置订单详情
    this.RESET_DETAIL();
    // 请求订单详情
    this.id = this.$route.params.id;
    this.getDetail();
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variables.scss";

.company-applyment-module {
  .applyment-page-header {
    background-color: #fff;
    // padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .page-header-heading-left {
      display: none;
    }

    .page-header-heading-content {
      width: 620px;
    }

    .page-header-heading-right {
      .opts {
        display: inline-block;
      }
    }
    .status {
      display: inline-block;
      font-size: 20px;
      font-weight: bold;
      margin-right: 20px;
      color: #12a3ff;
    }
    .status::before {
      display: inline-block;
      content: "";
      background: #12a3ff;
      width: 6px;
      height: 6px;
      border-radius: 6px;
      vertical-align: middle;
      margin-right: 4px;
      margin-top: -4px;
    }
  }
  .applyment-page-header-top {
    .affix {
      z-index: 1030 !important;
    }
    .page-header-heading-left {
      display: inline-block;
    }
    .page-header-heading-content {
      display: none;
    }
    .status-label {
      display: none;
    }
  }

  .applyment-page-header-shrink {
    .affix {
      left: $sidebar-width !important;
      width: calc(100% - #{$sidebar-width} - 18px) !important;
    }
  }

  .applyment-page-header-unfold {
    .affix {
      left: $sidebar-full-width !important;
      width: calc(100% - #{$sidebar-full-width} - 18px) !important;
    }
  }

  .steps-bar-wrapper {
    position: fixed;
    right: 6px;
    top: 38vh;
    z-index: 1000;
  }

  .desp {
    color: rgb(53, 55, 68);

    .desp-header {
      font-size: 18px;
      padding: 10px 5px 10px;
      border-bottom: 1px solid #ebeef0;
      margin-bottom: 15px;
      color: #011a45;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 700;
    }

    .desp-items-group {
      & + .desp-items-group {
        margin-top: 24px;
      }
    }

    .desp-items-group-title {
      padding: 1px 14px;
      font-size: 16px;
      margin-bottom: 10px;
      width: fit-content;
      border-left: 3px solid #eee;
      color: #011a45;
      font-weight: bold;
    }

    .desp-items-group-title-icon {
      padding: 1px 14px;
      font-size: 16px;
      margin-bottom: 10px;
      width: fit-content;
      color: #011a45;
      font-weight: bold;
    }

    .desp-items-group-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 10px;
      color: #0060ff;
      // border-left: 3px solid #eee;
      background: #eceff9;
      margin-bottom: 15px;

      .title {
        font-weight: bold;
        font-size: 16px;
      }
    }

    .desp-item {
      overflow: hidden;
    }

    .desp-item-label {
      width: 166px;
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #667288;
      line-height: 40px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
    }

    .desp-item-label:after {
      content: ":";
      position: relative;
      top: -0.5px;
      margin: 0 8px 0 2px;
    }

    .desp-item-content {
      margin-left: 136px;
      line-height: 40px;
      position: relative;
      font-size: 14px;
      color: #011a45;
    }

    .desp-item-self {
      width: 100%;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0 12px 0;
      box-sizing: border-box;
    }

    .desp-item-form {
      width: 100%;
      vertical-align: middle;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0;
      box-sizing: border-box;
    }
  }
}
</style>
